/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type {AddUsersRequest} from '../models/AddUsersRequest';
import type {AddUsersResponse} from '../models/AddUsersResponse';
import type {AdminOfficeResponse} from '../models/AdminOfficeResponse';
import type {AIAdminStatusResponse} from '../models/AIAdminStatusResponse';
import type {AIAdminUserResponse} from '../models/AIAdminUserResponse';
import type {EligibleUserResponse} from '../models/EligibleUserResponse';
import type {OfficeEmailSlugSettingsResponse} from '../models/OfficeEmailSlugSettingsResponse';
import type {OpenFileStatusSettingsResponse} from '../models/OpenFileStatusSettingsResponse';
import type {QcOutputDocumentTypeResponse} from '../models/QcOutputDocumentTypeResponse';
import type {QcTriggerDocumentTypesResponse} from '../models/QcTriggerDocumentTypesResponse';
import type {QcUnsignedPackageDocumentTypesResponse} from '../models/QcUnsignedPackageDocumentTypesResponse';
import type {SetAIAccessRequest} from '../models/SetAIAccessRequest';
import type {SetQcAccessRequest} from '../models/SetQcAccessRequest';
import type {SetQcOutputDocumentTypeRequest} from '../models/SetQcOutputDocumentTypeRequest';
import type {SetQcTriggerDocumentTypesRequest} from '../models/SetQcTriggerDocumentTypesRequest';
import type {SetQcUnsignedPackageDocumentTypesRequest} from '../models/SetQcUnsignedPackageDocumentTypesRequest';
import type {UpdateOfficeEmailSlugsRequest} from '../models/UpdateOfficeEmailSlugsRequest';
import type {UpdateOpenFileStatusesRequest} from '../models/UpdateOpenFileStatusesRequest';
import type {CancelablePromise} from '../core/CancelablePromise';
import type {BaseHttpRequest} from '../core/BaseHttpRequest';
export class AiAdminService {
  constructor(public readonly httpRequest: BaseHttpRequest) {}
  /**
   * Returns the current user's AI Admin status: whether their role grants the ManageUserAccess permission.
   * @returns AIAdminStatusResponse OK
   * @throws ApiError
   */
  public aiAdminGetMyAdminStatus(): CancelablePromise<AIAdminStatusResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/api/ai-admin/me',
    });
  }
  /**
   * Returns all org members with their current AI access status.
   * Only accessible to callers whose role grants ManageUserAccess.
   * @returns AIAdminUserResponse OK
   * @throws ApiError
   */
  public aiAdminGetOrgUsers(): CancelablePromise<Array<AIAdminUserResponse>> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/api/ai-admin/users',
      errors: {
        403: `Forbidden`,
      },
    });
  }
  /**
   * Invites one or more Resware users into the organization with the given role. Each invited user
   * appears as a pending row in  until they accept. Only accessible to
   * callers whose role grants ManageUserAccess.
   * @returns AddUsersResponse OK
   * @throws ApiError
   */
  public aiAdminAddUsers({
    requestBody,
  }: {
    requestBody: AddUsersRequest;
  }): CancelablePromise<AddUsersResponse> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/api/ai-admin/users',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        403: `Forbidden`,
      },
    });
  }
  /**
   * Returns Resware internal users who are not yet AI Assistant org members and have no pending
   * invitation -- candidates for the "Add user" flow. Only accessible to callers whose role grants
   * ManageUserAccess.
   * @returns EligibleUserResponse OK
   * @throws ApiError
   */
  public aiAdminGetEligibleUsers(): CancelablePromise<
    Array<EligibleUserResponse>
  > {
    return this.httpRequest.request({
      method: 'GET',
      url: '/api/ai-admin/eligible-users',
      errors: {
        403: `Forbidden`,
      },
    });
  }
  /**
   * Sets whether a specific user has AI access. Only callers whose role grants ManageUserAccess can call this.
   * @returns void
   * @throws ApiError
   */
  public aiAdminSetUserAiAccess({
    userId,
    requestBody,
  }: {
    userId: string;
    requestBody: SetAIAccessRequest;
  }): CancelablePromise<void> {
    return this.httpRequest.request({
      method: 'PUT',
      url: '/api/ai-admin/users/{userId}/ai-access',
      path: {
        userId: userId,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        403: `Forbidden`,
        404: `Not Found`,
      },
    });
  }
  /**
   * Sets whether a specific user has Post-Closing QC access. Only callers whose role grants ManageUserAccess can call this.
   * @returns void
   * @throws ApiError
   */
  public aiAdminSetUserQcAccess({
    userId,
    requestBody,
  }: {
    userId: string;
    requestBody: SetQcAccessRequest;
  }): CancelablePromise<void> {
    return this.httpRequest.request({
      method: 'PUT',
      url: '/api/ai-admin/users/{userId}/qc-access',
      path: {
        userId: userId,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        403: `Forbidden`,
        404: `Not Found`,
      },
    });
  }
  /**
   * Returns the organization's configured Post-Closing QC trigger document types plus audit metadata.
   * Only callers whose role grants ManageUserAccess can call this.
   * @returns QcTriggerDocumentTypesResponse OK
   * @throws ApiError
   */
  public aiAdminGetQcTriggerDocumentTypes(): CancelablePromise<QcTriggerDocumentTypesResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/api/ai-admin/qc/trigger-document-types',
      errors: {
        403: `Forbidden`,
      },
    });
  }
  /**
   * Replaces the organization's Post-Closing QC trigger document types (replace semantics; send an
   * empty list to clear). Only callers whose role grants ManageUserAccess can call this.
   * @returns QcTriggerDocumentTypesResponse OK
   * @throws ApiError
   */
  public aiAdminSetQcTriggerDocumentTypes({
    requestBody,
  }: {
    requestBody: SetQcTriggerDocumentTypesRequest;
  }): CancelablePromise<QcTriggerDocumentTypesResponse> {
    return this.httpRequest.request({
      method: 'PUT',
      url: '/api/ai-admin/qc/trigger-document-types',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        403: `Forbidden`,
      },
    });
  }
  /**
   * Returns the organization's configured Post-Closing QC output document type plus audit
   * metadata. Only callers whose role grants ManageUserAccess can call this.
   * @returns QcOutputDocumentTypeResponse OK
   * @throws ApiError
   */
  public aiAdminGetQcOutputDocumentType(): CancelablePromise<QcOutputDocumentTypeResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/api/ai-admin/qc/output-document-type',
      errors: {
        403: `Forbidden`,
      },
    });
  }
  /**
   * Replaces the organization's Post-Closing QC output document type (replace semantics; send
   * null to clear). Only callers whose role grants ManageUserAccess can call this.
   * @returns QcOutputDocumentTypeResponse OK
   * @throws ApiError
   */
  public aiAdminSetQcOutputDocumentType({
    requestBody,
  }: {
    requestBody: SetQcOutputDocumentTypeRequest;
  }): CancelablePromise<QcOutputDocumentTypeResponse> {
    return this.httpRequest.request({
      method: 'PUT',
      url: '/api/ai-admin/qc/output-document-type',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request`,
        403: `Forbidden`,
      },
    });
  }
  /**
   * Returns the organization's configured Post-Closing QC unsigned-package document types plus
   * audit metadata. Only callers whose role grants ManageUserAccess can call this.
   * @returns QcUnsignedPackageDocumentTypesResponse OK
   * @throws ApiError
   */
  public aiAdminGetQcUnsignedPackageDocumentTypes(): CancelablePromise<QcUnsignedPackageDocumentTypesResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/api/ai-admin/qc/unsigned-package-document-types',
      errors: {
        403: `Forbidden`,
      },
    });
  }
  /**
   * Replaces the organization's Post-Closing QC unsigned-package document types (replace
   * semantics; send an empty list to clear). Only callers whose role grants ManageUserAccess can
   * call this.
   * @returns QcUnsignedPackageDocumentTypesResponse OK
   * @throws ApiError
   */
  public aiAdminSetQcUnsignedPackageDocumentTypes({
    requestBody,
  }: {
    requestBody: SetQcUnsignedPackageDocumentTypesRequest;
  }): CancelablePromise<QcUnsignedPackageDocumentTypesResponse> {
    return this.httpRequest.request({
      method: 'PUT',
      url: '/api/ai-admin/qc/unsigned-package-document-types',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        403: `Forbidden`,
      },
    });
  }
  /**
   * Returns every selectable Resware file status with the caller's organization's current
   * open-status selection. Only callers whose role grants ManageUserAccess can call this.
   * @returns OpenFileStatusSettingsResponse OK
   * @throws ApiError
   */
  public aiAdminGetOpenFileStatuses(): CancelablePromise<OpenFileStatusSettingsResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/api/ai-admin/open-file-statuses',
      errors: {
        403: `Forbidden`,
      },
    });
  }
  /**
   * Replaces the caller's organization's open-status selection. An empty list clears it and
   * returns the organization to the deployment default.
   * The organization comes from the caller's validated token rather than the request, so an
   * administrator can only ever configure their own company.
   * @returns OpenFileStatusSettingsResponse OK
   * @throws ApiError
   */
  public aiAdminSetOpenFileStatuses({
    requestBody,
  }: {
    requestBody: UpdateOpenFileStatusesRequest;
  }): CancelablePromise<OpenFileStatusSettingsResponse> {
    return this.httpRequest.request({
      method: 'PUT',
      url: '/api/ai-admin/open-file-statuses',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request`,
        403: `Forbidden`,
      },
    });
  }
  /**
   * Returns every office configured in the caller's Resware tenant, for the office-routing admin
   * surface. Unlike GET /api/me this is not scoped to the caller's own offices. Only callers whose
   * role grants ManageUserAccess can call this.
   * @returns AdminOfficeResponse OK
   * @throws ApiError
   */
  public aiAdminGetOffices(): CancelablePromise<Array<AdminOfficeResponse>> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/api/ai-admin/offices',
      errors: {
        403: `Forbidden`,
      },
    });
  }
  /**
   * Returns the caller's organization's inbound-address slug to office mappings, used to route
   * incoming email to an office. Only callers whose role grants ManageUserAccess can call this.
   * @returns OfficeEmailSlugSettingsResponse OK
   * @throws ApiError
   */
  public aiAdminGetOfficeEmailSlugs(): CancelablePromise<OfficeEmailSlugSettingsResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/api/ai-admin/office-email-slugs',
      errors: {
        403: `Forbidden`,
      },
    });
  }
  /**
   * Replaces the caller's organization's slug-to-office mappings. An empty list clears them, after
   * which inbound email is no longer routed by office.
   * The organization comes from the caller's validated token rather than the request, so an
   * administrator can only ever configure their own company.
   * @returns OfficeEmailSlugSettingsResponse OK
   * @throws ApiError
   */
  public aiAdminSetOfficeEmailSlugs({
    requestBody,
  }: {
    requestBody: UpdateOfficeEmailSlugsRequest;
  }): CancelablePromise<OfficeEmailSlugSettingsResponse> {
    return this.httpRequest.request({
      method: 'PUT',
      url: '/api/ai-admin/office-email-slugs',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request`,
        403: `Forbidden`,
      },
    });
  }
}
